<template>
  <div class="popup-contain">
    <!-- For add appointment page -->
    <div class="save-event-contain">
      <!-- Question -->
      <p>
        There is already an appointment in this time slot. Do you still want to
        add this new appointment?
      </p>

      <!-- Only for this option -->
      <div class="save-this-event" @click.prevent.stop="setOverLapCheckAllowed">
        Yes
      </div>

      <!-- Fot the future option -->
      <div
        class="save-future-event"
        @click.prevent.stop="setOverLapCheck('NOT_CHECKED')"
      >
        No
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
export default {
  name: "OverlapPopup",
  methods: {
    ...mapMutations({
      setOverLapCheck: "setOverLapCheck" // Set weather overlap is allowed
    }),
    ...mapActions({
      submitForm: "submitForm" // Function when form sumbit has been clicked
    }),
    /**
     * Set overlap to allowed
     * Submit form at the end
     */
    setOverLapCheckAllowed() {
      this.setOverLapCheck("ALLOWED");
      this.submitForm();
    }
  }
};
</script>
